import GroupRecapBlock from './GroupRecapBlock';

export default GroupRecapBlock;
